import { SDK } from 'lawyer-manager'

import { env } from '@app/env'

export const lawyerManagerSDK = () => {
  return new SDK(env.REACT_APP_LAWYER_MANAGER_PUBLIC_URL)
}
